import { useRef } from "react";
import { useClickInterception } from "@repo/shared-components";
import { MetadataInput } from "./metadata-input/metadata-input";
import type { FieldUnion } from "./utils/field-type-guards";

type Props = {
  selectedField: FieldUnion | null;
  selectedIndex: number | null;
  hasUnsavedChanges: boolean;
  showDiscardDialog: (onConfirmed?: () => void) => void;
  onSave: (field: FieldUnion) => void;
  onHasUnsavedChanges: (hasChanges: boolean, onDiscard: () => void) => void;
  existingNames: string[];
  onClose?: () => void;
};

export const MetadataFieldEditor = ({
  selectedField,
  selectedIndex,
  hasUnsavedChanges,
  showDiscardDialog,
  onSave,
  onHasUnsavedChanges,
  existingNames,
  onClose,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useClickInterception(containerRef, hasUnsavedChanges, showDiscardDialog, onClose);

  return (
    <div ref={containerRef}>
      <MetadataInput
        key={selectedField ? `${selectedField.name}-${selectedIndex}` : "empty"}
        field={selectedField}
        existingNames={existingNames}
        onSave={onSave}
        onHasUnsavedChanges={onHasUnsavedChanges}
      />
    </div>
  );
};
